import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import cancelOfferModalStyles from "./styles/styles";
import { useTranslation } from "react-i18next";

const CancelOfferModel = (props) => {
  const {
    open,
    handleClose,
    handleCancelRequest,
    // communityData,
    dialogTitle,
    dialogHeading,
    isLoading,
  } = props;
  // const { name } = communityData;

  const {
    dialogPaper,
    dialogTitle: dialogTitleStyle,
    closeIconButton,
    dialogContent,
    dialogActions,
    backButtonStyle,
    cancelButtonStyle,
    loader,
  } = cancelOfferModalStyles;

  const { t } = useTranslation("supplier-join-offers-modal");

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown
      PaperProps={{ sx: dialogPaper }}
    >
      <DialogTitle sx={dialogTitleStyle}>{dialogTitle}</DialogTitle>
      <IconButton aria-label="close" onClick={handleClose} sx={closeIconButton}>
        <CloseIcon sx={{ color: "rgba(62, 63, 76, 1)", fontSize: "24px" }} />
      </IconButton>

      <DialogContent sx={dialogContent}>{dialogHeading}</DialogContent>

      <DialogActions sx={dialogActions}>
        <Button variant="contained" sx={backButtonStyle} onClick={handleClose}>
          {t("back")}
        </Button>

        <Button
          onClick={handleCancelRequest}
          disabled={isLoading}
          sx={cancelButtonStyle}
        >
          {t("yes_cancel")}
          {isLoading && <CircularProgress size={20} sx={loader} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelOfferModel;
